import { handleNumber } from './util';
import ProcessingFee from './ProcessingFee';

const getGrandTotal = (orders, isFormated = true, pass) => {
  let grandTotal = 0;
  orders.forEach((order) => {
    if (order.flag === 'success' || order.flag === 'info' || pass) {
      order.items.forEach((item) => {
        grandTotal += item.sub_total_inc_shipping;
      });
    }
  });
  return isFormated ? handleNumber(grandTotal, 2, true, '$') : grandTotal;
};

function toFixedNumber(num, digs = 2) {
  return parseFloat(num.toFixed(digs));
}

const getGrandTotalWithProcFee = (orders, isFormated = true, pass) => {
  const grandTotal = getGrandTotal(orders, false, pass);
  const processingFee = ProcessingFee.fromOrders(orders, false, pass);
  const price = grandTotal + processingFee;
  return isFormated ? handleNumber(price, 2, true, '$') : price;
};

const getSubTotal = (orders, isFormated = true, pass) => {
  let subTotal = 0;
  orders.forEach((order) => {
    if (order.flag === 'success' || order.flag === 'info' || pass) {
      // subTotal += order.total_amount;
      order.items.forEach((item) => {
        subTotal += item.sub_total_inc_shipping;
      });
    }
  });

  return isFormated ? handleNumber(subTotal, 2, true, '$') : subTotal;
};

const getGST = (orders, noFee, isFormated = true, pass) => {
  if (isNZGSTApplicable(orders[0].country, orders[0].order_date)) {
    const processingFee = ProcessingFee.fromOrders(orders, false, pass);
    let gst = processingFee / 11;
    if(noFee){
      gst = 0;
    }
    return isFormated ? handleNumber(gst, 2, true, '$') : gst;
  } else {
    // For paid orders, total_amount already includes postage_surcharge so use it directly.
    // For unpaid orders, total_amount is not yet finalised so sum per-item instead.
    let grandTotal = 0;
    orders.forEach((order) => {
      if (order.flag === 'success' || order.flag === 'info' || pass) {
        if (order.status !== 'unpaid') {
          grandTotal += Number(order.total_amount || 0);
        } else {
          order.items.forEach((item) => {
            grandTotal += item.sub_total_inc_shipping;
          });
          // Surcharge, handling fee and pallet fee are not yet folded into item totals for unpaid orders; add
          // them so GST matches the payable total shown on ShippingAndPayment.
          grandTotal += Number(order.postage_surcharge || 0);
          grandTotal += Number(order.handling_fee || 0);
          grandTotal += Number(order.pallet_fee || 0);
        }
      }
    });
    const processingFee = noFee ? 0 : ProcessingFee.fromOrders(orders, false, pass);
    const gst = (grandTotal + processingFee) / 11;
    return isFormated ? handleNumber(gst, 2, true, '$') : gst;
  }
};

const isNZGSTApplicable = (orderCountry, orderDate) => {
  const nzCutoffDate = process.env.REACT_APP_NZ_GST_CUTOFF_TIME
  const orderDateTimestamp = new Date(orderDate).getTime();
  const cutoffDateTimestamp = new Date(nzCutoffDate).getTime();
  return orderCountry === "NZ" && orderDateTimestamp > cutoffDateTimestamp;
}

const OrderPrice = {
  getGrandTotal,
  getGrandTotalWithProcFee,
  getSubTotal,
  getGST,
  toFixedNumber,
  isNZGSTApplicable
};

export default OrderPrice;
